import { useCallback } from 'react';
import { Control } from 'react-hook-form';

import { MediaFormInput } from 'apps/card/scripts/types';
import { MediaType } from 'apps/shared/scripts/__generated__/graphql.generated';
import { Giphy } from 'apps/shared/scripts/components';

import { FORM_FIELDS } from '../constants';
import { FormValues } from '../types';

interface Props {
  control: Control<FormValues>;
}

const GifField = ({ control }: Props) => {
  const toFormValue = useCallback((id: string) => {
    return { src: id, type: MediaType.Giphy };
  }, []);

  const fromFormValue = useCallback(
    (value?: MediaFormInput): string | undefined => {
      return value?.src;
    },
    [],
  );

  return (
    <Giphy
      control={control}
      name={FORM_FIELDS.MEDIA.name}
      toFormValue={toFormValue}
      fromFormValue={fromFormValue}
    />
  );
};

GifField.displayName = 'GifField';

export default GifField;
